module.exports = {"vesselName":"","vessel":"","open":[{"namePort":"","where":"","from":"","until":""}],"preferredCargo":"","terms":[],"user":"","validateErrors":[],"successMessage":{},"loadingPortName":"","maintenance":null,"disponentOwner":{"name":""}}


//////////////////
// WEBPACK FOOTER
// ./app/mocks/vessel/order.json
// module id = 670
// module chunks = 0